import type { NoteKind } from "@/lib/types";

/** Request body for a new note. An unset date is left out so the server stamps its own local today. */
export function notePayload(kind: NoteKind, body: string, day: string, contactId: string) {
  return { kind, body: body.trim(), contactId: contactId === "none" ? null : Number(contactId), ...(day ? { occurredAt: day } : {}) };
}
